module.exports = __webpack_public_path__ + "static/media/seasonal_decliner_white.dc764e1a.svg";